import script from "./FeesConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeesConfiguration.vue?vue&type=script&setup=true&lang=ts"

import "./FeesConfiguration.vue?vue&type=style&index=0&id=46c1236a&lang=css"
import "./FeesConfiguration.vue?vue&type=style&index=1&id=46c1236a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c1236a"]])

export default __exports__